import { gql } from '@apollo/client'

const typeDefs = gql`
  type Query {
    departures(
      fromDate: String!
      toDate: String!
      portCode: String
      routeCode: String
      skip: Int
      take: Int
    ): [Departure!]!
    nasdaq(startDate: String!, endDate: String!, locale: String!): [Nasdaq]
    nasdaqById(id: String!, lang: String!): Nasdaq
    nasdaqChartLatest(companycode: String!): NasdaqChartLatest
    nasdaqChartHistory(companycode: String!, interval: Int!): NasdaqChartHistory
    nasdaqShareInfo(companycode: String!): NasdaqShareInfo
  }
  type Vacancy {
    vacancyId: String
    language: String
    companyName: String
    title: String
    activeFromDate: String
    activeToDate: String
    commence: String
    workplace: String
    deadline: String
    vacancyUrl: String
    country: String
    departmentName: String
  }
  type Departure {
    departureId: String
    scheduledDepartureTime: String
    scheduledArrivalTime: String
    route: Direction
  }
  type Direction {
    departurePort: Port
    arrivalPort: Port
  }
  type Port {
    code: String
    name: String
    unlocode: String
    timezone: String
  }
  type Nasdaq {
    id: String
    date: String
    title: String
    link: String
    messagetype: String
    message: String
    attachments: [Attachment]
  }
  type NasdaqChartLatest {
    ISIN: String
    Name: String
    MarketName: String
    Currency: String
    Data: [NasdaqChartLatestData]
  }
  type NasdaqChartLatestData {
    DateTime: String
    Close: String
    Volume: String
  }
  type NasdaqChartHistory {
    ISIN: String
    Name: String
    MarketName: String
    Currency: String
    Data: [NasdaqChartHistoryData]
  }
  type NasdaqChartHistoryData {
    Date: String
    Open: String
    Volume: String
    High: String
    Low: String
  }
  type NasdaqShareInfo {
    Currency: String
    Bid: String
    Ask: String
    Change: String
    ChangePercent: String
    Last: String
    High: String
    Low: String
    Volume: String
    PreviousClose: String
    Date: String
    ISIN: String
    Symbol: String
    MarketName: String
    NoShares: String
    MarketCap: String
    Open: String
  }
  type Attachment {
    filename: String
    url: String
  }
`

export default typeDefs
